//can be used to create the schema based on columns for API call
export const tableMappingAPI = (channelFilter = 'Omni') => {
	if (channelFilter === 'Omni') {
		return {
			sales: {
				netSales: {
					ty: 'ty_ns',
					percentYoY: 'percentYoY_ns',
					absoluteYoY: 'absoluteYoY_ns',
					durationType: 'durationType',
				},
				units: {
					ty: 'ty_units',
					percentYoY: 'percentYoY_units',
					absoluteYoY: 'absoluteYoY_units',
					durationType: 'durationType',
				},
				aur: {
					ty: 'ty_aur',
					percentYoY: 'percentYoY_aur',
					absoluteYoY: 'absoluteYoY_aur',
					durationType: 'durationType',
				},
			},
			channelBreakdown: {
				bis: {
					ty: 'ty_bis',
					percentYoY: 'percentYoY_bis',
					absoluteYoY: 'absoluteYoY_bis',
					durationType: 'durationType',
				},
				pickup: {
					ty: 'ty_pickup',
					percentYoY: 'percentYoY_pickup',
					absoluteYoY: 'absoluteYoY_pickup',
					durationType: 'durationType',
				},
				delivery: {
					ty: 'ty_delivery',
					percentYoY: 'percentYoY_delivery',
					absoluteYoY: 'absoluteYoY_delivery',
					durationType: 'durationType',
				},
				sfs: {
					ty: 'ty_sfs',
					percentYoY: 'percentYoY_sfs',
					absoluteYoY: 'absoluteYoY_sfs',
					durationType: 'durationType',
				},
				s2s: {
					ty: 'ty_s2s',
					percentYoY: 'percentYoY_s2s',
					absoluteYoY: 'absoluteYoY_s2s',
					durationType: 'durationType',
				},
				s2h: {
					ty: 'ty_s2h',
					percentYoY: 'percentYoY_s2h',
					absoluteYoY: 'absoluteYoY_s2h',
					durationType: 'durationType',
				},
			},
		};
	} else if (channelFilter === 'eCom') {
		return {
			sales: {
				netSales: {
					ty: 'ty_ns',
					percentYoY: 'percentYoY_ns',
					absoluteYoY: 'absoluteYoY_ns',
					durationType: 'durationType',
				},
				units: {
					ty: 'ty_units',
					percentYoY: 'percentYoY_units',
					absoluteYoY: 'absoluteYoY_units',
					durationType: 'durationType',
				},
				aur: {
					ty: 'ty_aur',
					percentYoY: 'percentYoY_aur',
					absoluteYoY: 'absoluteYoY_aur',
					durationType: 'durationType',
				},
			},
			channelBreakdown: {
				// name: 'Fulfillment Channel Sales Breakdown',
				s2s: {
					ty: 'ty_s2s',
					percentYoY: 'percentYoY_s2s',
					absoluteYoY: 'absoluteYoY_s2s',
					durationType: 'durationType',
				},
				s2h: {
					ty: 'ty_s2h',
					percentYoY: 'percentYoY_s2h',
					absoluteYoY: 'absoluteYoY_s2h',
					durationType: 'durationType',
				},
			},
		};
	} else {
		return {
			sales: {
				netSales: {
					ty: 'ty_ns',
					percentYoY: 'percentYoY_ns',
					absoluteYoY: 'absoluteYoY_ns',
					durationType: 'durationType',
				},
				units: {
					ty: 'ty_units',
					percentYoY: 'percentYoY_units',
					absoluteYoY: 'absoluteYoY_units',
					durationType: 'durationType',
				},
				aur: {
					ty: 'ty_aur',
					percentYoY: 'percentYoY_aur',
					absoluteYoY: 'absoluteYoY_aur',
					durationType: 'durationType',
				},
			},
			channelBreakdown: {
				bis: {
					ty: 'ty_bis',
					percentYoY: 'percentYoY_bis',
					absoluteYoY: 'absoluteYoY_bis',
					durationType: 'durationType',
				},
				pickup: {
					ty: 'ty_pickup',
					percentYoY: 'percentYoY_pickup',
					absoluteYoY: 'absoluteYoY_pickup',
					durationType: 'durationType',
				},
				delivery: {
					ty: 'ty_delivery',
					percentYoY: 'percentYoY_delivery',
					absoluteYoY: 'absoluteYoY_delivery',
					durationType: 'durationType',
				},
				sfs: {
					ty: 'ty_sfs',
					percentYoY: 'percentYoY_sfs',
					absoluteYoY: 'absoluteYoY_sfs',
					durationType: 'durationType',
				},
			},
			inventory: {
				storeOnHand: {
					ty: 'ty_soh',
					percentYoY: 'percentYoY_soh',
					absoluteYoY: 'absoluteYoY_soh',
					durationType: 'durationType',
				},
				storeOnOrder: {
					ty: 'ty_soo',
					percentYoY: 'percentYoY_soo',
					absoluteYoY: 'absoluteYoY_soo',
					durationType: 'durationType',
				},
				storeDcToStore: {
					ty: 'ty_sdts',
					percentYoY: 'percentYoY_sdts',
					absoluteYoY: 'absoluteYoY_sdts',
					durationType: 'durationType',
				},
				totalStoreInventory: {
					ty: 'ty_tsi',
					percentYoY: 'percentYoY_tsi',
					absoluteYoY: 'absoluteYoY_tsi',
					durationType: 'durationType',
				},
				storeInWhse: {
					ty: 'ty_siw',
					percentYoY: 'percentYoY_siw',
					absoluteYoY: 'absoluteYoY_siw',
					durationType: 'durationType',
				},
			},
			replenishment: {
				storeInStockPercentage: {
					ty: 'ty_sisp',
					percentYoY: 'percentYoY_sisp',
					absoluteYoY: 'absoluteYoY_sisp',
					durationType: 'durationType',
				},
			},
			pointsOfDistribution: {
				traitedStoreCount: {
					ty: 'ty_traitedStore',
					percentYoY: 'percentYoY_traitedStore',
					absoluteYoY: 'absoluteYoY_traitedStore',
					durationType: 'durationType',
				},
				traitedItemCount: {
					ty: 'ty_traitedItem',
					percentYoY: 'percentYoY_traitedItem',
					absoluteYoY: 'absoluteYoY_traitedItem',
					durationType: 'durationType',
				},
				validStoreCount: {
					ty: 'ty_validStore',
					percentYoY: 'percentYoY_validStore',
					absoluteYoY: 'absoluteYoY_validStore',
					durationType: 'durationType',
				},
			},
			velocity: {
				dollarSW: {
					ty: 'ty_dollarSW',
					percentYoY: 'percentYoY_dollarSW',
					absoluteYoY: 'absoluteYoY_dollarSW',
					durationType: 'durationType',
				},
				unitSW: {
					ty: 'ty_unitSW',
					percentYoY: 'percentYoY_unitSW',
					absoluteYoY: 'absoluteYoY_unitSW',
					durationType: 'durationType',
				},
			},
			opd: {
				ftpr: {
					ty: 'ty_ftpr',
					// percentYoY: 'percentYoY_ftpr',
					// absoluteYoY: 'absoluteYoY_ftpr',
					durationType: 'durationType',
				},
				nilPics: {
					ty: 'ty_nilPics',
					// percentYoY: 'percentYoY_nilPics',
					// absoluteYoY: 'absoluteYoY_nilPics',
					durationType: 'durationType',
				},
				presubRate: {
					ty: 'ty_presubRate',
					// percentYoY: 'percentYoY_presubRate',
					// absoluteYoY: 'absoluteYoY_presubRate',
					durationType: 'durationType',
				},
				postsubRate: {
					ty: 'ty_postsubRate',
					// percentYoY: 'percentYoY_postsubRate',
					// absoluteYoY: 'absoluteYoY_postsubRate',
					durationType: 'durationType',
				},
				totalOrderQuantity: {
					ty: 'ty_toq',
					// percentYoY: 'percentYoY_toq',
					// absoluteYoY: 'absoluteYoY_toq',
					durationType: 'durationType',
				},
				presubQty: {
					ty: 'ty_presubQty',
					// percentYoY: 'percentYoY_presubQty',
					// absoluteYoY: 'absoluteYoY_presubQty',
					durationType: 'durationType',
				},
				subQty: {
					ty: 'ty_subQty',
					// percentYoY: 'percentYoY_subQty',
					// absoluteYoY: 'absoluteYoY_subQty',
					durationType: 'durationType',
				},
				nilPicQty: {
					ty: 'ty_nilPicQty',
					// percentYoY: 'percentYoY_nilPicQty',
					// absoluteYoY: 'absoluteYoY_nilPicQty',
					durationType: 'durationType',
				},
			},
		};
	}
};

// mapping keys so that for the Drawer
export const mappingKeys = {
	'Net Sales': 'ns',
	Units: 'units',
	AUR: 'aur',
	'Buy In Store': 'bis',
	'Pick up': 'pickup',
	Delivery: 'delivery',
	'Ship From Store': 'sfs',
	'Ship To Home': 's2h',
	'Ship To Store': 's2s',
	'Store On Hand Quantity': 'soh',
	'Store On Order Quantity': 'soo',
	'Store In Transit Quantity': 'sdts',
	'Store In Warehouse Quantity': 'siw',
	'Total Store Inventory': 'tsi',
	'Repl Instock %': 'sisp',
	'Traited Store Count': 'traitedStore',
	'Traited Item Count': 'traitedItem',
	'Valid Store Count': 'validStore',
	'Dollar/Store/Week(Day)': 'dollarSW',
	'Units/Store/Week(Day)': 'unitSW',
	'Total Order Quantity': 'toq',
	'Pre Substitute Quantity': 'presubQty',
	'Substitute Quantity': 'subQty',
	'Nil Pick Quantity': 'nilPicQty',
	'First Time Pick Rate': 'ftpr',
	'Nil Pick Rate': 'nilPics',
	'Pre Substitute Rate': 'presubRate',
	'Post Substitute Rate': 'postsubRate',
};

export const fieldMetricMapping = {
	ty_ns: 'NET_SALES',
	absoluteYoY_ns: 'NET_SALES_ABS_YOY',
	percentYoY_ns: 'NET_SALES_PERCENT_YOY',

	ty_units: 'UNITS',
	absoluteYoY_units: 'UNITS_ABS_YOY',
	percentYoY_units: 'UNITS_PERCENT_YOY',

	ty_aur: 'AUR',
	absoluteYoY_aur: 'AUR_ABS_YOY',
	percentYoY_aur: 'AUR_PERCENT_YOY',

	ty_bis: 'BIS',
	absoluteYoY_bis: 'BIS_ABS_YOY',
	percentYoY_bis: 'BIS_PERCENT_YOY',

	ty_pickup: 'PICKUP',
	absoluteYoY_pickup: 'PICKUP_ABS_YOY',
	percentYoY_pickup: 'PICKUP_PERCENT_YOY',

	ty_delivery: 'DELIVERY',
	absoluteYoY_delivery: 'DELIVERY_ABS_YOY',
	percentYoY_delivery: 'DELIVERY_PERCENT_YOY',

	// Were not in the email shared by Naga
	ty_sfs: 'SFS',
	absoluteYoY_sfs: 'SFS_ABS_YOY',
	percentYoY_sfs: 'SFS_PERCENT_YOY',

	ty_s2h: 'S2H',
	absoluteYoY_s2h: 'S2H_ABS_YOY',
	percentYoY_s2h: 'S2H_PERCENT_YOY',

	ty_s2s: 'S2S',
	absoluteYoY_s2s: 'S2S_ABS_YOY',
	percentYoY_s2s: 'S2S_PERCENT_YOY',

	// ty_eComm: 'ECOMM',
	// absoluteYoY_eComm: 'ECOMM_ABS_YOY',
	// percentYoY_eComm: 'ECOMM_PERCENT_YOY',
	// Inventory Fields
	/************************************ */

	ty_soh: 'STORE_ON_HAND',
	absoluteYoY_soh: 'STORE_ON_HAND_ABS_YOY',
	percentYoY_soh: 'STORE_ON_HAND_PERCENT_YOY',

	ty_soo: 'STORE_ON_ORDER',
	absoluteYoY_soo: 'STORE_ON_ORDER_ABS_YOY',
	percentYoY_soo: 'STORE_ON_ORDER_PERCENT_YOY',

	// ty_dcToStore: "DC2S",
	// absoluteYoY_dcToStore: "DC2S_ABS_YOY",
	// percentYoY_dcToStore: "DC2S_PERCENT_YOY",

	ty_sdts: 'STORE_DC_TO_STORE',
	absoluteYoY_sdts: 'STORE_DC_TO_STORE_ABS_YOY',
	percentYoY_sdts: 'STORE_DC_TO_STORE_PERCENT_YOY',

	ty_siw: 'STORE_IN_WHSE',
	absoluteYoY_siw: 'STORE_IN_WHSE_ABS_YOY',
	percentYoY_siw: 'STORE_IN_WHSE_PERCENT_YOY',

	ty_tsi: 'TOTAL_STORE_INVENTORY',
	absoluteYoY_tsi: 'TOTAL_STORE_INVENTORY_ABS_YOY',
	percentYoY_tsi: 'TOTAL_STORE_INVENTORY_PERCENT_YOY',

	ty_sisp: 'REPL_STORE_INSTOCK',
	absoluteYoY_sisp: 'REPL_STORE_INSTOCK_ABS_YOY',
	percentYoY_sisp: 'REPL_STORE_INSTOCK_PERCENT_YOY',

	ty_traitedStore: 'TRAIT_STORE_COUNT',
	absoluteYoY_traitedStore: 'TRAIT_STORE_COUNT_ABS_YOY',
	percentYoY_traitedStore: 'TRAIT_STORE_COUNT_PERCENT_YOY',

	ty_validStore: 'VALID_STORE_COUNT',
	absoluteYoY_validStore: 'VALID_STORE_COUNT_ABS_YOY',
	percentYoY_validStore: 'VALID_STORE_COUNT_PERCENT_YOY',

	ty_traitedItem: 'TRAIT_ITEM_COUNT',
	absoluteYoY_traitedItem: 'TRAIT_ITEM_COUNT_ABS_YOY',
	percentYoY_traitedItem: 'TRAIT_ITEM_COUNT_PERCENT_YOY',

	ty_dollarSW: 'DOLLARSW',
	absoluteYoY_dollarSW: 'DOLLARSW_ABS_YOY',
	percentYoY_dollarSW: 'DOLLARSW_PERCENT_YOY',

	ty_unitSW: 'UNITSW',
	absoluteYoY_unitSW: 'UNITSW_ABS_YOY',
	percentYoY_unitSW: 'UNITSW_PERCENT_YOY',

	ty_toq: 'TOTAL_ORDER_QUANTITY',
	absoluteYoY_toq: 'TOTAL_ORDER_QUANTITY_ABS_YOY',
	percentYoY_toq: 'YoY_change_totalOrderQty',

	ty_presubQty: 'PRE_SUB_QUANTITY',
	absoluteYoY_presubQty: 'PRE_SUB_QUANTITY_ABS_YOY',
	percentYoY_presubQty: 'PRE_SUB_QUANTITY_PERCENT_YOY',

	/*********** We don't have these columns */
	ty_subQty: 'SUB_QUANTITY',
	absoluteYoY_subQty: 'SUB_QUANTITY_ABS_YOY',
	percentYoY_subQty: 'SUB_QUANTITY_PERCENT_YOY',

	ty_nilPicQty: 'NIL_PICK_QUANTITY',
	absoluteYoY_nilPicQty: 'NIL_PICK_QUANTITY_ABS_YOY',
	percentYoY_nilPicQty: 'NIL_PICK_QUANTITY_PERCENT_YOY',

	ty_ftpr: 'FTPR',
	absoluteYoY_ftpr: 'FTPR_ABS_YOY',
	percentYoY_ftpr: 'FTPR_PERCENT_YOY',

	ty_nilPics: 'NIL_PICS',
	absoluteYoY_nilPics: 'NIL_PICS_ABS_YOY',
	percentYoY_nilPics: 'NIL_PICS_PERCENT_YOY',

	ty_presubRate: 'PRE_SUB_RATE',
	absoluteYoY_presubRate: 'PRE_SUB_RATE_ABS_YOY',
	percentYoY_presubRate: 'PRE_SUB_RATE_PERCENT_YOY',

	ty_postsubRate: 'POST_SUB_RATE',
	absoluteYoY_postsubRate: 'POST_SUB_RATE_ABS_YOY',
	percentYoY_postsubRate: 'POST_SUB_RATE_PERCENT_YOY',
};

const DOLLAR_REQUIRED_FIELDS = [
	'ty_ns',
	'absoluteYoY_ns',
	'ty_aur',
	'absoluteYoY_aur',
	'ty_bis',
	'absoluteYoY_bis',
	'ty_pickup',
	'absoluteYoY_pickup',
	'ty_delivery',
	'absoluteYoY_delivery',
	'ty_sfs',
	'absoluteYoY_sfs',
	'ty_dollarSW',
	'absoluteYoY_dollarSW',
	'ty_s2s',
	'ty_s2h',
	'absoluteYoY_s2h',
	'absoluteYoY_s2s',
].join(' ');

const PERCENTAGE_REQUIRED_FIELDS = [
	'percentYoY_ns',
	'percentYoY_units',
	'percentYoY_aur',
	'percentYoY_bis',
	'percentYoY_pickup',
	'percentYoY_delivery',
	'percentYoY_sfs',
	'percentYoY_soh',
	'percentYoY_soo',
	'percentYoY_sdts',
	'percentYoY_tsi',
	'percentYoY_siw',
	'percentYoY_dollarSW',
	'ty_postsubRate',
	'ty_presubRate',
	'ty_nilPics',
	'ty_ftpr',
	'percentYoY_s2h',
	'percentYoY_s2s',
	'percentYoY_sisp',
	'percentYoY_traitedStore',
	'percentYoY_traitedItem',
	'percentYoY_validStore',
	'percentYoY_unitSW',
].join(' ');

export const formatCellValue = (value, field) => {
	let prefix = '';
	let suffix = '';

	const [, fieldName1 = '', fieldName2 = ''] = field.split('_');
	// for example: this converts the column field name to ty_ns from WTD_ty_ns.
	const fieldName = `${fieldName1}_${fieldName2}`;

	// check if value is negative, and appended with prefix
	prefix += value < 0 ? '-' : '';

	// get the Units & suffix for the value
	if (DOLLAR_REQUIRED_FIELDS.includes(fieldName)) {
		prefix += '$';
	} else if (PERCENTAGE_REQUIRED_FIELDS.includes(fieldName)) {
		suffix += '%';
	}

	let formattedValue;
	if (typeof value === 'number' && !Number.isInteger(value)) {
		// If value is number & floating point value it is formatted with 2 decimal points
		const [number, decimal] = value.toFixed(2).split('.');
		formattedValue = `${prefix}${Math.abs(
			number
		)?.toLocaleString()}.${decimal}${suffix}`;
	} else {
		formattedValue = `${prefix}${Math.abs(value)?.toLocaleString()}${suffix}`;
	}

	return formattedValue;
};

export const getValueForExcel = (params) => {
	const value = params.value;
	if (value == null || value == undefined) {
		return '-';
	}

	if (value === -999999) return 'NA';

	if (params?.column?.userProvidedColDef?.cellClass === 'percentFormat') {
		return value / 100;
	}

	return value;
};

const graphQLQueryKeyMap = Object.freeze({
	// Segments
	Sales: 'sales',
	Velocity: 'velocity',
	Inventory: 'inventory',
	Replenishment: 'replenishment',
	OnlinePickupandDelivery: 'opd',
	PointsofDistribution: 'pointsOfDistribution',
	FulfillmentChannelSalesBreakdown: 'channelBreakdown',
	// Fields
	Units: 'units',
	NetSales: 'netSales',
	AUR: 'aur',
	Delivery: 'delivery',
	PickUp: 'pickup',
	BuyInStore: 'bis',
	ShipFromStore: 'sfs',
	ShipToHome: 's2h',
	ShiptoStore: 's2s',
	'StoreOn-Hand': 'storeOnHand',
	'StoreOnOrder(Intransit)': 'storeOnOrder',
	'StoreDCtoStore(Intransit)': 'storeDcToStore',
	'StoreInWHSE(Intransit)': 'storeInWhse',
	TotalStoreInventory: 'totalStoreInventory',
	NilPickQuantity: 'nilPicQty',
	PostSubstituteRate: 'postsubRate',
	PreSubstituteRate: 'presubRate',
	FirstTimePickRate: 'ftpr',
	NilPickRate: 'nilPics',
	TotalOrderQuantity: 'totalOrderQuantity',
	PreSubstituteQuantity: 'presubQty',
	SubstituteQuantity: 'subQty',
	'In-Stock%': 'storeInStockPercentage',
	TraitedStoreCount: 'traitedStoreCount',
	TraitedItemCount: 'traitedItemCount',
	ValidStoreCount: 'validStoreCount',
	'Dollar/Store/Week(Day)': 'dollarSW',
	'Units/Store/Week(Day)': 'unitSW',
});

// This converts the Custom Table Columns fields to GraphQL Query Keys in a nested Object format
export const getUserPreferenceMetrics = (input) => {
	if (!input || input.length === 0) {
		return {};
	}
	const result = {};
	input.forEach((metric) => {
		const metricName = graphQLQueryKeyMap[metric?.name?.replace(/\s/g, '')];
		const segments = metric?.metrics?.map(
			(segmentObj) => graphQLQueryKeyMap[segmentObj?.name?.replace(/\s/g, '')]
		);
		if (segments?.length > 0) {
			result[metricName] = segments;
		}
	});
	return result;
};

export const addExpandedGroupId = (groupId, groupsArray, roots = null) => {
	let finalGroupId = groupId + '_';
	let rootsStr = '';
	if (roots !== null) {
		rootsStr = roots.map((e) => e.id);
		rootsStr = rootsStr.join('_');
		finalGroupId = `${rootsStr}_${finalGroupId}`;
		if (!groupsArray.includes(finalGroupId)) {
			groupsArray.push(finalGroupId);
		}
	} else {
		if (!groupsArray.includes(finalGroupId)) {
			groupsArray.push(finalGroupId);
		}
	}

	// Add the new item to array
	return groupsArray;
};

export const removeExpandedGroupId = (groupId, groupsArray) => {
	let finalGroupId = groupId + '_';
	const result = groupsArray.filter(
		(element) => !element.includes(finalGroupId)
	);
	return result;
};

export const hasExpandedGroupId = (groupId, groupsArray, roots = null) => {
	// Check if the given groupId is available in groupsArray
	let finalGroupId = groupId + '_';
	let rootsStr = '';
	if (roots !== null) {
		rootsStr = roots.map((e) => e.id);
		rootsStr = rootsStr.join('_');
		finalGroupId = `${rootsStr}_${finalGroupId}`;
	}
	const result = groupsArray.filter((element) =>
		element.includes(finalGroupId)
	);
	if (result.length <= 0) {
		return false;
	} else {
		return true;
	}
};

export const isOtherExpanded = (groupsArray) => {
	return groupsArray.length > 0;
};
n